import React from "react"
import AddButtonNew from '../../AddButton/AddButtonNew'

class SelectChartTypeButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chart_type: null
    };
    this.onAdd = this.onAdd.bind(this);
  };

  render() {
    let href = (this.href())

    return (
      <div>
        <AddButtonNew
          model="ChartType" 
          text={I18n.t('new_chart')} 
          buttonClasses="btn btn-primary" 
          new_button={false} 
          onAdd={this.onAdd}
          generalPosition="right"
        />
        <a ref="hiddenLink" data-fullscreen="true" data-nested="true" href={href} className="modal-iframe" style={{ display: 'none' }}></a>
      </div>
    );
  };

  href() {
    if (this.state.chart_type && this.state.chart_type.id) {
      return `/admin/reports/report-details/${this.state.chart_type.id}/new-with-chart-type`
    } else { return null }
  };

  onAdd(json) {
    this.setState({ chart_type: json }, () => {
      $(this.refs.hiddenLink).trigger('click');
    });

  };
}

export default SelectChartTypeButton